import React from 'react';

const TAB_TITLES = {
  services: 'Services Flow',
  printers: 'Printers & Accessories',
  ismile: 'iSmile Cases',
};

export default function Header({ orderCount, serviceCount, activeTab }) {
  return (
    <header className="main-header">
      <div className="header-left">
        <h1 className="page-title">{TAB_TITLES[activeTab] || 'Order Flow'}</h1>
        {activeTab === 'services' && (
          <div className="header-counts">
            <span className="count-badge">
              <strong>{orderCount}</strong> orders
            </span>
            <span className="count-divider">/</span>
            <span className="count-badge">
              <strong>{serviceCount}</strong> services
            </span>
          </div>
        )}
      </div>
      <div className="header-right">
        <div className="live-indicator">
          <span className="live-dot" />
          Live
        </div>
        <div className="user-avatar">
          <span>SP</span>
        </div>
      </div>
    </header>
  );
}
